import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { message } from 'ant-design-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BatchCustomNameModal',
  props: {
    open: {
      type: Boolean
    },
    count: null
  },
  emits: ["update:open", "submit"],
  setup(__props, {
    expose,
    emit
  }) {
    const customName = ref('');
    const errorText = ref('');
    const saving = ref(false);
    const resetState = () => {
      customName.value = '';
      errorText.value = '';
      saving.value = false;
    };
    const handleCancel = () => {
      resetState();
      emit('update:open', false);
    };
    const handleOk = () => {
      const next = customName.value.trim();
      if (!next) {
        errorText.value = '请输入名称内容';
        message.warning('请输入名称内容');
        return;
      }
      emit('submit', next);
    };
    const close = () => {
      resetState();
      emit('update:open', false);
    };
    const setSaving = value => {
      saving.value = value;
    };
    expose({
      close,
      setSaving
    });
    return (_ctx, _cache) => {
      const _component_a_alert = _resolveComponent("a-alert");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: __props.open,
        title: "批量修改自定义商品名",
        "ok-text": "保 存",
        "cancel-text": "取 消",
        "confirm-loading": saving.value,
        "mask-closable": false,
        onOk: handleOk,
        onCancel: handleCancel
      }, {
        default: _withCtx(() => [_createVNode(_component_a_alert, {
          class: "selected-tip",
          type: "info",
          "show-icon": "",
          message: `已选择 ${__props.count} 个产品`
        }, null, 8, ["message"]), _createVNode(_component_a_form, {
          "label-col": {
            span: 24
          },
          "wrapper-col": {
            span: 24
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: "自定义商品名",
            required: "",
            "validate-status": errorText.value ? 'error' : '',
            help: errorText.value || undefined
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: customName.value,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => customName.value = $event),
              maxlength: 30,
              placeholder: "请输入自定义商品名",
              onChange: _cache[1] || (_cache[1] = $event => errorText.value = '')
            }, null, 8, ["value"])]),
            _: 1
          }, 8, ["validate-status", "help"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["open", "confirm-loading"]);
    };
  }
});